import React from "react"

const PageHeader = ({className, children}) => (
    <div className={`w-fit py-10 ${className}`}>
    <h1 className="text-4xl">{children}</h1>
    </div>
)

export default PageHeader